import * as React from 'react'

import { TFOrderForForm, useQOrderForFormLazyQuery } from '~graphql/generated/clientGraphql'

import { useLazyQueryContext } from '../../../helpers/useLazyQueryContext'
import { useOrderIdCtx } from '../../Order'

/**
 * Loads the data needed for initial render of the FormScreen
 * eg. order state or handover place/time data.
 */
export const useLoadFormOrder = () => {
  const { orderId } = useOrderIdCtx()
  const [order, setOrder] = React.useState<Nullable<TFOrderForForm>>(null)

  const context = useLazyQueryContext()
  // if the useQ hook would be used here, it could automagically refetch when some order mutating operation returns
  // (eg. when changing payment order tip or adding promo code)
  // -> this would trigger unnecessary full page re-render
  // because data loaded in this Q are supposed to be mostly static
  // this way it’s indeed run only once
  const [qOrderForForm] = useQOrderForFormLazyQuery({ context })

  React.useEffect(() => {
    if (order) {
      return
    }

    if (!orderId) {
      return
    }

    const queryOrderOnce = async () => {
      const { data, error } = await qOrderForForm({ variables: { orderId } })

      if (error || !data) return

      setOrder(data.order)
    }

    queryOrderOnce()
  }, [order, orderId, qOrderForForm])

  return order
}
